import React, { useEffect } from "react";
import "./AboutUs.css";
import Navbar from "../Navbar";
import AOS from "aos";
import "aos/dist/aos.css";
import scroll from "../img/arrow.png"

const AboutUs = () => {
  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
  });
  return (
    <div>
      <Navbar />
      <div className="about_div">
        <div className="aboutDiv">
          <h1>About Us</h1>
        <img src={scroll} alt="" className="scroll"/>
        </div>
      </div>
      <div className="about_div2" data-aos="zoom-in">
        <h1 className="h17">ABOUT US</h1>
        <p className="p8">
          Bentraco Logistics is one of the best Limousine and Trucking service
          providers in the USA. We value safety, luxury and reliability. We have
          trained and professional drivers to serve you, Therefore we deliver a
          tremendous exceptional chauffeur experience with a commitment to
          security, hospitality and punctuality.
        </p>
        <p className="p8">
          In order to make your ride more comfortable, we offer complimentary
          beverages, magazines and newspapers. Our team never compromise on high
          standard and quality, we will give everything you need for a beautiful
          experience in any desired location.
        </p>
      </div>
    </div>
  );
};

export default AboutUs;
